const endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/telemetry/client-errors`;
const storageKey = "gsp_pending_diagnostics";
let sending = false;
let installed = false;
const seen = new Map();

const pathOnly = (value) => {
  try { return new URL(value || window.location.href, window.location.origin).pathname.replace(/\/(quote|book)\/[^/]+/g, "/$1/[redacted]"); }
  catch { return ""; }
};
const scrub = (value, limit = 1800) => String(value || "")
  .replace(/Bearer\s+\S+/gi, "Bearer [redacted]")
  .replace(/eyJ[\w-]+\.[\w-]+\.[\w-]+/g, "[token redacted]")
  .replace(/data:[^\s,]+,[A-Za-z0-9+/=]+/g, "[file data redacted]")
  .replace(/(password|secret|token|authorization|api_key)["']?\s*[:=]\s*["']?[^\s,}"']+/gi, "$1=[redacted]")
  .replace(/https?:\/\/[^\s<>"']+/g, pathOnly)
  .replace(/[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}/g, "[email redacted]")
  .slice(0, limit);
const pending = () => { try { const items = JSON.parse(localStorage.getItem(storageKey) || "[]"); return Array.isArray(items) ? items : []; } catch { return []; } };
const save = (items) => { try { localStorage.setItem(storageKey, JSON.stringify(items.slice(-30))); } catch { /* storage unavailable */ } };

export const flushClientErrors = async () => {
  if (sending || !navigator.onLine) return;
  const item = pending()[0];
  if (!item) return;
  sending = true;
  try {
    const token = localStorage.getItem("gsp_token");
    const response = await fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: JSON.stringify(item), keepalive: true });
    if (response.ok || response.status === 422) save(pending().slice(1));
  } catch { /* Keep bounded redacted reports for the next successful connection. */ }
  finally { sending = false; }
};

export const reportClientError = (error, kind = "javascript", route) => {
  const message = scrub(error?.message || error || "Unknown browser error");
  const key = `${kind}:${message}:${pathOnly(route)}`;
  const now = Date.now();
  if ((seen.get(key) || 0) > now - 30000) return;
  seen.set(key, now);
  if (seen.size > 100) seen.delete(seen.keys().next().value);
  save([...pending(), { message, kind, route: pathOnly(route), stack: scrub(error?.stack || "", 4500) }]);
  void flushClientErrors();
};

export const reportNetworkError = (error) => {
  if (String(error?.config?.url || "").includes("/telemetry/")) return;
  if (!error?.response || (error.response.status >= 500 && !error.response.headers?.["x-request-id"])) {
    reportClientError(new Error(error?.response ? `API gateway returned HTTP ${error.response.status}` : "API connection failed"), "network", error?.config?.url);
  }
  return Promise.reject(error);
};

export const installErrorReporting = () => {
  if (installed) return;
  installed = true;
  // Server-rendered PDF browsers have their own phase/asset diagnostics.
  if (new URLSearchParams(window.location.search).has("print")) return;
  window.addEventListener("error", (event) => {
    if (event.target && event.target !== window && (event.target.src || event.target.href)) {
      reportClientError(`Resource could not be loaded: ${pathOnly(event.target.src || event.target.href)}`, "resource");
    } else reportClientError(event.error || event.message);
  }, true);
  window.addEventListener("unhandledrejection", (event) => reportClientError(event.reason instanceof Error ? event.reason : "Unhandled asynchronous browser error", "unhandled-promise"));
  window.addEventListener("online", flushClientErrors);
  window.setInterval(flushClientErrors, 10000);
  void flushClientErrors();
};